import { Range } from "@pdfking/tfunc"

export const range = (n1: number, n2?: number, step = 1) => [
  ...Range(n1, n2, step),
]
